import React from 'react';
import './MenuComponent.css'
//import pic from '../pictures/Image 554.png'

function Menu() {
    return (
            <div className="firstimg">
                <div className="patch">
                </div>
                <div className="patch_content">
                    <div className="content">WORLD-CLASS 3 & 4 BED RESIDENCES FROM RS. 2.42 CR.*</div>
                    <div className="place">Bhivadi Harayna</div>
                    <div className="location">View Location</div>
                    <div className="know">
                        <div>Enquire now</div>
                    </div>
                    <div className="develop">Developers</div>
                    <div className="symbol">
                        <div className="accent">Accent</div>
                        <div className="build1">Buidtech Pvt Ltd.</div>
                    </div>
                </div>
        </div>
    );
}

export default Menu